import { makeObservable, observable, flow } from "mobx";
import { NotificationStore, PaginationStore } from "@common/stores";
import { IRecentUserClientRequestModel } from "@common/models/requests/RecentUserClientRequestModel";
import { ClientConfigurationModel, ClientListingModel, IClientListingModel, IClientModel } from "@common/models";
import { UserService } from "@common/services/userService";

export interface IClientRecentResultsStoreInit {
	configuration: ClientConfigurationModel;
	notificationStore: NotificationStore;
}
export class ClientRecentResultsStore extends PaginationStore<IClientListingModel> {
	notificationStore: NotificationStore;
	@observable configuration: ClientConfigurationModel;
	@observable client?: IClientModel = undefined;
	@observable loading: boolean = false;
	@observable recentClients: Array<ClientListingModel> = [];

	constructor(init: IClientRecentResultsStoreInit) {
		super();

		const { configuration, notificationStore } = init;

		this.configuration = configuration;
		this.notificationStore = notificationStore;

		makeObservable(this, undefined);
	}

	/**
	 * Provides implementation for providing a list of recently viewed clients to pagination store
	 * @returns list of recently viewed clients
	 */
	protected getDefaultRecentResults(): IClientListingModel[] {
		return this.recentClients;
	}

	/**
	 * Adds a client to the recently viewed for that userId
	 */
	addRecentlyViewed = flow(function* (this: ClientRecentResultsStore, clientId: any) {
		const request: IRecentUserClientRequestModel = {
			userId: this.configuration.userId,
			clientId: clientId,
		};

		yield UserService.addRecentClient(request).catch(() => this.notificationStore.error("Failed to add to recently viewed clients"));
	});

	/**
	 * Get top 50 recently viewed clients for the currently logged in userId
	 */
	getRecentlyViewedClients = flow(function* (this: ClientRecentResultsStore) {
		const userId = this.configuration.userId;
		this.recentClients = yield UserService.getRecentClients(userId)
			.then(recentClients => recentClients.map(element => element.toClientListingModel()))
			.catch(() => this.notificationStore.error("Failed to retrieve recently viewed clients"));
	});
}
